import { resolveCloudScreenshotUrl } from "../../../../lib/utils";

const CUSTOM_SCREENSHOTS_BASE = "instructions/screenshots";
const cloudScreenshot = (relativePath) => resolveCloudScreenshotUrl(`${CUSTOM_SCREENSHOTS_BASE}/${relativePath}`);

export const MISSION_ONE_SCREENSHOT_LAYOUT_BY_PAGE = {
 m101: {
  src: cloudScreenshot(`screenshots_m1/instructions 1.01.svg`),
  title: "NEXT MISSION",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 42,
  maxWidthPercent: 48,
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
 m102: {
  src: cloudScreenshot(`screenshots_shared/instructions 0.04 1.02.svg`),
  title: "Step 1: Approach Target",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 43,
  maxWidthPercent: 48,
  details: [
   { left: 39, top: 37.3, key: "KeyZ", fontSizeVw: 0.92 },
   { left: 60.5, top: 37.3, key: "Slash", fontSizeVw: 0.92 },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m103: {
  src: cloudScreenshot(`screenshots_m1/instructions 1.03.svg`),
  title: "Step 2: Identify Mafia Type",
  leftPercent: 60,
  topPercent: 3.7,
  widthPercent: 64,
  maxWidthPercent: 64,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m104: {
  src: cloudScreenshot(`screenshots_m1/instructions 1.04.svg`),
  title: "Step 3: Crack Code",
  leftPercent: 59.65,
  topPercent: 3.7,
  widthPercent: 63.2,
  maxWidthPercent: 63.2,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m105: {
  src: cloudScreenshot(`screenshots_shared/instructions 0.07 1.05.svg`),
  title: "Step 4: Move Driver",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 43,
  maxWidthPercent: 48,
  details: [
   { left: 39.1, top: 39.9, key: "KeyZ", fontSizeVw: 0.92 },
   { left: 40.3, top: 35.5, key: "KeyS", fontSizeVw: 0.92 },
   { left: 42.8, top: 35.5, key: "KeyD", fontSizeVw: 0.92 },
   { left: 45.1, top: 35.5, key: "KeyF", fontSizeVw: 0.92 },
   { left: 54.9, top: 35.5, key: "KeyK", fontSizeVw: 0.92 },
   { left: 57.3, top: 35.5, key: "KeyL", fontSizeVw: 0.92 },
   { left: 59.8, top: 35.5, key: "Semicolon", fontSizeVw: 0.92 },
   { left: 60.96, top: 39.9, key: "Slash", fontSizeVw: 0.92 },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m106: {
  src: cloudScreenshot(`screenshots_m1/instructions 1.06.svg`),
  title: "Step 5: Feedback (1)",
  leftPercent: 44,
  topPercent: 10,
  widthPercent: 57,
  maxWidthPercent: 57,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m107: {
  src: cloudScreenshot(`screenshots_m1/instructions 1.08.svg`),
  title: "Step 5: Feedback (2)",
  leftPercent: 60.05,
  topPercent: 10,
  widthPercent: 62.6,
  maxWidthPercent: 62.6,
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m108: {
  src: cloudScreenshot(`screenshots_shared/instructions 2.05 1.07 0.13.svg`),
  title: "Check-Ins",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 48,
  details: [
   { left: 48.4, top: 54.4, key: "KeyS", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 50.55, top: 54.4, key: "KeyD", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 52.65, top: 54.4, key: "KeyF", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 54.7, top: 54.4, key: "KeyK", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 56.8, top: 54.4, key: "KeyL", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
   { left: 58.9, top: 54.4, key: "Semicolon", fontSizeVw: 0.74, color: "#000000", textStroke: "0px" },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 41,
  titleTopVw: -0.25,
 },
 m109: {
  src: cloudScreenshot(`screenshots_shared/instructions 0.15 1.09 3.07.svg`),
  title: "Game Controller",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 45,
  details: [
   { left: 39.1, top: 39.9, key: "KeyZ", fontSizeVw: 1.22 },
   { left: 40.3, top: 35, key: "KeyS", fontSizeVw: 1.22 },
   { left: 42.8, top: 35, key: "KeyD", fontSizeVw: 1.22 },
   { left: 45.1, top: 35, key: "KeyF", fontSizeVw: 1.22 },
   { left: 54.9, top: 35, key: "KeyK", fontSizeVw: 1.22 },
   { left: 57.3, top: 35, key: "KeyL", fontSizeVw: 1.22 },
   { left: 59.8, top: 35, key: "Semicolon", fontSizeVw: 1.22 },
   { left: 60.96, top: 39.9, key: "Slash", fontSizeVw: 1.22 },
  ],
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
 m110: {
  src: cloudScreenshot(`screenshots_shared/instructions 0.16 1.10.svg`),
  title: "Ready to Play",
  leftPercent: 50,
  topPercent: 10,
  widthPercent: 45,
  maxWidthPercent: 45,
  titleWidthPercent: 28,
  titleLeftPercent: 50,
  titleTopVw: -0.25,
 },
};
